<ng-container *ngIf="data.endDateType === 'DATE'">{{ data.endDate | date: 'd MMM, y' }}</ng-container>
<ng-container *ngIf="data.endDateType === 'YEARS_MONTHS'"
  >{{ data.endYearsMonths.years }} years {{ data.endYearsMonths.months }} months</ng-container
>
